import axios from "axios";

const configuredApi = (process.env.VUE_APP_API_URL || "").replace(/\/$/, "");

export const urlBase = configuredApi || "/api";

const Api = (configuracion = {}) => {
  const { tokenKey = "token", redirectOnUnauthorized = true } = configuracion;
  const token = localStorage.getItem(tokenKey);
  const headers = { Accept: "application/json" };

  if (token) headers.Authorization = `Bearer ${token}`;
  if (tokenKey === "token" && token) {
    const tenantSlug = localStorage.getItem("active_tenant_slug");
    if (tenantSlug) headers["X-Tenant-Slug"] = tenantSlug;
  }

  const api = axios.create({
    baseURL: urlBase,
    headers,
    timeout: 30000,
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response ? error.response.status : null;

      if (status === 401) {
        localStorage.removeItem(tokenKey);
        if (redirectOnUnauthorized) {
          localStorage.removeItem("permisos");
          localStorage.removeItem("userData");
          window.location.href = "/login";
        }
      }

      if (status === 403 && redirectOnUnauthorized) {
        window.location.href = "/no-autorizado";
      }

      return Promise.reject(error);
    }
  );

  return api;
};

export default Api;
